import { useCallback, useEffect, useState } from 'react'

import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'

import ModalEmailMessages from 'Components/ModalEmailMessages/ModalEmailMessages'
import ModalEndCondition from 'Components/ModalEndCondition/ModalEndCondition'
import ModalSmsMessages from 'Components/ModalSmsMessages/ModalSmsMessages'
import safeHtml from 'Helpers/safeHtml'
import { modalEmailMessagesState } from 'Hooks/useModalEmailMessages/useModalEmailMessages'
import useModalEndCondition, {
  ANY_ITEM,
  COPY,
  DO_NOTHING,
  MOVE,
  modalEndConditionState
} from 'Hooks/useModalEndCondition/useModalEndCondition'
import { modalSmsMessagesState } from 'Hooks/useModalSmsMessages/useModalSmsMessages'
import ModalInvalidFirstStep from 'Pages/Workflow/components/Modals/ModalInvalidFirstStep'
import ChangeEmailStatusItem from 'Pages/Workflow/components/Step3/ChangeEmailStatusItem'
import {
  copyMessageCallback,
  copyMessageSmsCallback,
  getEmailSelectedMessageCallback,
  getSmsSelectedMessageCallback,
  saveStep3Callback
} from 'Pages/Workflow/recoil/callbacks/callbacks'
import {
  workflowCommonDataState,
  workflowDetails
} from 'Pages/Workflow/recoil/state/data'
import {
  modalInvalidFirstStepState,
  modalUsedMessageState
} from 'Pages/Workflow/recoil/state/modals'
import { pageState, wizardSteps } from 'Pages/Workflow/recoil/state/page'
import { step3State } from 'Pages/Workflow/recoil/state/step3'

import {
  ACTION_BUTTON_TYPE_EDIT,
  ButtonAction,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'
import uniqid from 'uniqid'
import EmailItem from './EmailItem'

import SmsItem from './SmsItem'

import * as S from './WorkflowBuilder.styles'
import {
  changeWorkflowStep,
  copyWorkflowStep,
  deleteWorkflowStep,
  reorderWorkflowSteps
} from './actions'

import Sidebar from './WorkflowBuilderSidebar'

import WaitItem from './WaitItem'

import { ModalStepThirdWorkflowMessageUsed } from '../Modals/ModalStepThirdWorkflowMessageUsed'
import StyledIconFlag from './StyledIconFlag'

import { OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE } from 'Constants/index'
import useGetWorkflowSidebar from 'Pages/Workflow/useGetWorkflowSidebar'

const queryAttr = 'data-rbd-drag-handle-draggable-id'

const WorkflowBuilder = () => {
  const intl = useIntl()
  const escapeStrong = (t) => <strong>{t}</strong>

  // init modalEndCondition
  const { fetchGroups, fetchGroup } = useModalEndCondition()

  const { Type } = useRecoilValue(workflowDetails)

  const { Step, EndFromGroup, EndToGroup } = useRecoilValue(step3State)

  const { conditionsDescription } = useRecoilValue(workflowCommonDataState)

  const [steps, setSteps] = useState(
    []
    //      Step.map((o) => ({ ...o, id: uniqid('workflow-step-') }))
  )
  const [placeholderProps, setPlaceholderProps] = useState({})

  const [currentDragItem, setCurrentDragItem] = useState('')

  const setWizardStep = useSetRecoilState(wizardSteps)
  const setWorkflowDetails = useSetRecoilState(step3State)
  const setPageState = useSetRecoilState(pageState)

  const setModalEmailState = useSetRecoilState(modalEmailMessagesState)
  const { droppableId: droppablEmailMessageId, showEmailLoader } =
    useRecoilValue(modalEmailMessagesState)
  const getEmailSelectedMessage = useRecoilCallback(
    getEmailSelectedMessageCallback,
    []
  )
  const getSmsSelectedMessage = useRecoilCallback(
    getSmsSelectedMessageCallback,
    []
  )
  const setModalSmsState = useSetRecoilState(modalSmsMessagesState)
  const { droppableId: droppablSmsMessageId, showSmsLoader } = useRecoilValue(
    modalSmsMessagesState
  )

  const copyMessageEmail = useRecoilCallback(copyMessageCallback, [])
  const copyMessageSms = useRecoilCallback(copyMessageSmsCallback, [])
  const [
    {
      check,
      copyValue,
      moveToValue,
      moveFromValue,
      items: groupItems,
      loaded: groupsLoadedFirstTime
    },
    setModalEndConditionState
  ] = useRecoilState(modalEndConditionState)
  const [{ show: showUsed, entityName, type }, setModalUsedMessageState] =
    useRecoilState(modalUsedMessageState)

  //
  const saveStep3 = useRecoilCallback(saveStep3Callback, [])
  const { show: showModalInvalidFirstStep } = useRecoilValue(
    modalInvalidFirstStepState
  )
  const resetModalInvalidFirstStep = useResetRecoilState(
    modalInvalidFirstStepState
  )

  useEffect(() => {
    setPageState((prev) => ({
      ...prev,
      loading: showEmailLoader
    }))
  }, [showEmailLoader])

  useEffect(() => {
    setPageState((prev) => ({
      ...prev,
      loading: showSmsLoader
    }))
  }, [showSmsLoader])

  //  onChanges: local to recoil
  useEffect(() => {
    setWorkflowDetails((prev) => ({ ...prev, Step: steps }))
  }, [steps])

  useEffect(() => {
    if (Step.some(({ id }) => !id)) {
      setSteps(
        Step.map((o) => ({
          ...o,
          id: o.id || uniqid('workflow-step-')
        }))
      )
    }
  }, [Step])

  const setModalConditionParams = async () => {
    const objModelCopy = {
      label: '',
      value: -1
    }
    const objModelMoveFrom = {
      label: '',
      value: -1
    }
    const objModelMoveTo = {
      label: '',
      value: -1
    }
    let check = DO_NOTHING
    // devo prevdere il caso con 0 e quindi prendo aggiungere anyItems
    groupItems.slice(0).push(ANY_ITEM)

    // cerco nella lista locale, prima pagina
    let endFromGroup = groupItems.find((el) => el.value === EndFromGroup)
    let endToGroup = groupItems.find((el) => el.value === EndToGroup)

    if (EndFromGroup === -1 && EndToGroup > 0) {
      check = COPY
      if (!endToGroup) {
        // non presente nella lista locale, cerco su API
        endToGroup = await fetchGroup(EndToGroup)
      }
      objModelCopy.label = endToGroup.label
      objModelCopy.value = EndToGroup
    } else if (EndFromGroup > -1 && EndToGroup > 0) {
      check = MOVE
      if (!endFromGroup && EndFromGroup > 0) {
        // non presente nella lista locale, cerco su API
        endFromGroup = await fetchGroup(EndFromGroup)
      }
      if (!endToGroup) {
        // non presente nella lista locale, cerco su API
        endToGroup = await fetchGroup(EndToGroup)
      }
      objModelMoveFrom.label = EndFromGroup > 0 ? endFromGroup.label : ''
      objModelMoveFrom.value = EndFromGroup
      objModelMoveTo.label = endToGroup.label
      objModelMoveTo.value = EndToGroup
    }
    setModalEndConditionState((prev) => ({
      ...prev,
      check,
      copyValue: objModelCopy,
      moveFromValue: objModelMoveFrom,
      moveToValue: objModelMoveTo
    }))
  }

  useEffect(() => {
    if (groupsLoadedFirstTime) {
      setModalConditionParams()
    }
  }, [groupsLoadedFirstTime])

  const items = useGetWorkflowSidebar()

  const dropAreaID = 'dropArea'

  const onDragStart = (item) => {
    // if (item && item.source.droppableId === 'dropArea') {
    //   setCurrentDragItem(item.draggableId)
    // }
    if (item.source && item.source.droppableId === 'dropArea') {
      setCurrentDragItem(item.draggableId)

      const draggableId = item.draggableId
      const destinationIndex = item.source.index

      const domQuery = `[${queryAttr}='${draggableId}']`
      const draggedDOM = document.querySelector(domQuery)

      const destinationDomQuery = `[data-rbd-droppable-id='dropArea']`
      const destinationDOM = document.querySelector(destinationDomQuery)

      const { clientHeight } = draggedDOM || {
        clientHeight: '40px'
      }

      const clientY = [...destinationDOM.children]
        .slice(0, destinationIndex)
        .reduce((total, curr) => {
          const style = curr.currentStyle || window.getComputedStyle(curr)
          const marginBottom = parseFloat(style.marginBottom)
          return total + curr.clientHeight + marginBottom
        }, 0)

      setPlaceholderProps((prev) => ({
        ...prev,
        clientHeight,
        clientY
      }))
    }
  }

  const onDragUpdate = (update) => {
    if (
      update.destination &&
      update.destination.droppableId === 'dropArea' &&
      update.source &&
      update.source.droppableId !== 'items'
    ) {
      if (update && update.source.droppableId === 'dropArea') {
        setCurrentDragItem(update.draggableId)
      }
      const draggableId = update.draggableId
      const destinationIndex = update.destination.index

      const domQuery = `[${queryAttr}='${draggableId}']`
      const draggedDOM = document.querySelector(domQuery)

      const destinationDomQuery = `[data-rbd-droppable-id='dropArea']`
      const destinationDOM = document.querySelector(destinationDomQuery)

      const { clientHeight } = draggedDOM || { clientHeight: '40px' }

      const clientY = [...destinationDOM.children]
        .slice(0, destinationIndex)
        .reduce((total, curr) => {
          const style = curr.currentStyle || window.getComputedStyle(curr)
          const marginBottom = parseFloat(style.marginBottom)
          return total + curr.clientHeight + marginBottom
        }, 0)

      setPlaceholderProps({
        clientHeight,
        clientWidth: '100%',
        clientY
      })
    }
  }

  const onDragEnd = (result) => {
    const { source, destination } = result
    setCurrentDragItem('') // reset
    setPlaceholderProps({}) // reset
    // dropped outside the list
    if (!destination) {
      return
    }

    switch (source.droppableId) {
      case destination.droppableId:
        setSteps(reorderWorkflowSteps(source.index, destination.index))

        break

      case 'items':
        setSteps(copyWorkflowStep(items[source.index], destination.index))

        break
    }
  }

  const handleEditStart = () => {
    setWizardStep((prev) => ({
      ...prev,
      wizardStep: 2
    }))
  }

  const handleDelete = (droppableId) => {
    setSteps(deleteWorkflowStep(droppableId))
  }

  const handleChange = (droppableId, data) => {
    setSteps(changeWorkflowStep(droppableId, data))
  }

  // apre modale di Email e SMS per la selezione, passa il droppableId
  const handleEdit = (droppableId, type) => {
    if (type === WORKFLOW_MESSAGE_TYPE_EMAIL) {
      setModalEmailState((prev) => ({
        ...prev,
        show: true,
        droppableId
      }))
    } else {
      setModalSmsState((prev) => ({
        ...prev,
        show: true,
        droppableId
      }))
    }
  }

  // ***** EMAIL

  // chiude la modale di selezione, controlla se il messaggio è usato in un altro workflow o in pagina
  // se il ret della funzione è != undefined vuol dire che non è utilizzato e quindi può essere
  // usato nell'item
  const handleEmailConfirm = useCallback(async (e, value, droppableId) => {
    setModalEmailState((prev) => ({
      ...prev,
      show: false,
      showEmailLoader: true
    }))
    const ret = await getEmailSelectedMessage(value, steps, droppableId)
    if (ret) {
      const data = {
        actionType: 'edit_type',
        payload: {
          subject: value.Subject,
          IdMessage: value.Id,
          type: WORKFLOW_MESSAGE_TYPE_EMAIL
        }
      }
      setSteps(changeWorkflowStep(droppableId, data))
      setModalUsedMessageState((prev) => ({
        ...prev,
        show: false
      }))
    }
    setModalEmailState((prev) => ({
      ...prev,
      showEmailLoader: false
    }))
  })
  // chiude la finestra di selezione email
  const handleEmailCancel = () => {
    setModalEmailState((prev) => ({
      ...prev,
      show: false,
      droppableId: ''
    }))
  }
  // ***** FINE EMAIL

  // ***** SMS
  const handleSmsConfirm = useCallback(async (e, value, droppableId) => {
    setModalSmsState((prev) => ({
      ...prev,
      show: false,
      showSmsLoader: true
    }))
    const ret = await getSmsSelectedMessage(value, steps, droppableId)
    if (ret) {
      const data = {
        actionType: 'edit_type',
        payload: {
          subject: value.Subject,
          IdMessage: value.Id,
          type: WORKFLOW_MESSAGE_TYPE_SMS
        }
      }
      setSteps(changeWorkflowStep(droppableId, data))
      setModalUsedMessageState((prev) => ({
        ...prev,
        show: false
      }))
    }
    setModalSmsState((prev) => ({
      ...prev,
      showSmsLoader: false
    }))
  })

  const handleSmsCancel = () => {
    setModalSmsState((prev) => ({
      ...prev,
      show: false,
      droppableId: ''
    }))
  }
  // ***** FINE SMS

  // gestione della modale per un messaggio utilizzato in una ltro workflow
  const handleMessageUsedCancel = () => {
    setModalUsedMessageState((prev) => ({
      ...prev,
      show: false
    }))
  }

  const handleMessageUsedConfirm = async () => {
    setModalUsedMessageState((prev) => ({
      ...prev,
      show: false
    }))

    if (type === WORKFLOW_MESSAGE_TYPE_EMAIL) {
      setModalEmailState((prev) => ({
        ...prev,
        showEmailLoader: true
      }))
      const ret = await copyMessageEmail()
      if (ret) {
        const data = {
          actionType: 'edit_type',
          payload: {
            subject: ret.Subject,
            IdMessage: ret.IdMessage,
            type: WORKFLOW_MESSAGE_TYPE_EMAIL
          }
        }
        setSteps(changeWorkflowStep(droppablEmailMessageId, data))
        setModalEmailState((prev) => ({
          ...prev,
          fetchAfterCopy: true,
          showEmailLoader: false
        }))
      }
    } else {
      setModalSmsState((prev) => ({
        ...prev,
        showSmsLoader: true
      }))
      const ret = await copyMessageSms()
      if (ret) {
        const data = {
          actionType: 'edit_type',
          payload: {
            subject: ret.Subject,
            IdMessage: ret.Id,
            type: WORKFLOW_MESSAGE_TYPE_EMAIL
          }
        }
        setSteps(changeWorkflowStep(droppablSmsMessageId, data))
        setModalSmsState((prev) => ({
          ...prev,
          fetchAfterCopy: true,
          showSmsLoader: false
        }))
      }
    }
  }

  // FINE USED MESSAGE

  const handleEndConditionCancel = () => {
    setModalEndConditionState((prev) => ({
      ...prev,
      show: false
    }))
  }

  const handleEndConditionConfirm = (e) => {
    setModalEndConditionState((prev) => ({
      ...prev,
      show: false
    }))

    // salvataggio locale
    let EndFromGroup = 0
    let EndToGroup = 0
    switch (check) {
      case DO_NOTHING:
        EndFromGroup = -1
        EndToGroup = 0
        break
      case COPY:
        EndFromGroup = -1
        EndToGroup = copyValue.value
        break
      case MOVE:
        EndFromGroup = moveFromValue.value
        EndToGroup = moveToValue.value
        break
    }
    setWorkflowDetails((prev) => ({ ...prev, EndFromGroup, EndToGroup }))
  }

  const handleSave = () => {
    saveStep3({ forceSave: true })
  }

  const fixedSteps =
    Type === OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE

  return (
    <S.WorkflowBuilderContainer>
      <ModalEmailMessages
        handleCancel={handleEmailCancel}
        handleConfirm={handleEmailConfirm}
        mode={Type === 'UnsubscriptionCampaign' ? 'Confirmation' : undefined}
      />
      <ModalSmsMessages
        handleCancel={handleSmsCancel}
        handleConfirm={handleSmsConfirm}
      />

      <ModalEndCondition
        handleCancel={handleEndConditionCancel}
        handleConfirm={handleEndConditionConfirm}
        fetchGroups={fetchGroups}
        fetchGroup={fetchGroup}
      />

      <ModalStepThirdWorkflowMessageUsed
        show={showUsed}
        handleCancel={handleMessageUsedCancel}
        handleConfirm={handleMessageUsedConfirm}
        name={entityName}
      />

      <ModalInvalidFirstStep
        show={showModalInvalidFirstStep}
        onCancel={resetModalInvalidFirstStep}
        onConfirm={handleSave}
      />

      <DragDropContext
        onDragEnd={onDragEnd}
        onDragStart={onDragStart}
        onDragUpdate={onDragUpdate}
      >
        <Sidebar items={items} />

        <S.RightContainer>
          <S.StyledTitle variant={TITLE_VARIANT_M} center>
            {intl.formatMessage({
              id: 'Load.AutomationWorkflow.TitleDragWorkflow'
            })}
          </S.StyledTitle>
          <S.RightContent>
            <S.DropAreaContainer>
              <S.Item>
                <S.InnerItem>
                  <S.ItemHorizontalLineStart
                    currentDragItem={currentDragItem}
                  />
                  <S.ItemStart>
                    <StyledIconFlag />
                    <div>
                      {intl.formatMessage({
                        id: 'Load.AutomationWorkflow.DragWorkflowStart'
                      })}
                    </div>
                  </S.ItemStart>
                  <S.WorkflowBuilderItem>
                    <S.ItemUnique>
                      <p>
                        {conditionsDescription &&
                          safeHtml(conditionsDescription.StartCondition)}
                      </p>
                    </S.ItemUnique>
                    <S.ItemActions>
                      <ButtonAction
                        type={ACTION_BUTTON_TYPE_EDIT}
                        onClick={handleEditStart}
                      />
                    </S.ItemActions>
                  </S.WorkflowBuilderItem>
                </S.InnerItem>
              </S.Item>

              <Droppable key={dropAreaID} droppableId={dropAreaID}>
                {(provided, snapshot) => (
                  <S.DropArea
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    isDraggingOver={snapshot.isDraggingOver}
                  >
                    {steps.length ? (
                      <>
                        {steps.map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={index}
                            isDragDisabled={fixedSteps}
                          >
                            {(provided, snapshot) => (
                              <S.Item
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                isDragging={snapshot.isDragging}
                                style={provided.draggableProps.style}
                                draggy
                              >
                                {item.StepType === 'SendEmail' && (
                                  <EmailItem
                                    draggableId={item.id}
                                    currentDragItem={currentDragItem}
                                    idMessage={item.IdMessage}
                                    subject={item.subject}
                                    onDelete={handleDelete}
                                    onEdit={handleEdit}
                                    canDelete={!fixedSteps}
                                  />
                                )}

                                {item.StepType === 'SendSms' && (
                                  <SmsItem
                                    draggableId={item.id}
                                    currentDragItem={currentDragItem}
                                    idMessage={item.IdMessage}
                                    subject={item.subject}
                                    onDelete={handleDelete}
                                    onEdit={handleEdit}
                                  />
                                )}

                                {item.StepType === 'Wait' && (
                                  <WaitItem
                                    currentDragItem={currentDragItem}
                                    draggableId={item.id}
                                    itemError={item.itemError}
                                    onChange={handleChange}
                                    onDelete={handleDelete}
                                    setSteps={setSteps}
                                    canDelete={!fixedSteps}
                                    toggleDisabled={fixedSteps}
                                    waitTypeDisabled={fixedSteps}
                                  />
                                )}

                                {item.StepType === 'ChangeStatus' && (
                                  <ChangeEmailStatusItem
                                    currentDragItem={currentDragItem}
                                    draggableId={item.id}
                                    EmailStatus={item.EmailStatus}
                                    EmailStatusCondition={
                                      item.EmailStatusCondition
                                    }
                                    itemError={item.itemError}
                                  />
                                )}
                              </S.Item>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                        <div
                          style={{
                            position: 'absolute',
                            top: placeholderProps.clientY,
                            left: '20px',
                            height: placeholderProps.clientHeight,
                            background: 'var(--mercury)',
                            width: 'calc(100% - 20px)',
                            borderRadius: '4px'
                          }}
                        />
                      </>
                    ) : (
                      <S.Notice>
                        {intl.formatMessage({
                          id: 'Load.AutomationWorkflow.WorkflowEmptyStateText'
                        })}
                      </S.Notice>
                    )}
                  </S.DropArea>
                )}
              </Droppable>

              <S.Item>
                <S.InnerItem>
                  <S.ItemHorizontalLineEnd currentDragItem={currentDragItem} />
                  <S.ItemEnd>
                    <div>
                      {intl.formatMessage({
                        id: 'Load.AutomationWorkflow.DragWorkflowEnd'
                      })}
                    </div>
                  </S.ItemEnd>
                  <S.WorkflowBuilderItem>
                    {Type ===
                      OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE && (
                      <S.ItemUnique>
                        <p>
                          {conditionsDescription &&
                            safeHtml(conditionsDescription.EndCondition)}
                        </p>
                      </S.ItemUnique>
                    )}
                    {Type !==
                      OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE && (
                      <S.ItemUnique>
                        <p>
                          {check === DO_NOTHING && (
                            <FormattedMessage
                              id='Load.AutomationWorkflow.EndConditionNothing'
                              values={{ strong: escapeStrong }}
                            />
                          )}

                          {check === COPY && copyValue && (
                            <FormattedMessage
                              id='Load.AutomationWorkflow.EndConditionCopyRecap'
                              values={{
                                strong: escapeStrong,
                                COPYGROUPNAME: copyValue.label
                              }}
                            />
                          )}

                          {check === MOVE &&
                            moveFromValue &&
                            moveToValue &&
                            moveFromValue.value !== 0 && (
                              <FormattedMessage
                                id='Load.AutomationWorkflow.EndConditionMoveRecap'
                                values={{
                                  strong: escapeStrong,
                                  GROUPNAME1: moveFromValue.label,
                                  GROUPNAME2: moveToValue.label
                                }}
                              />
                            )}

                          {check === MOVE &&
                            moveFromValue &&
                            moveToValue &&
                            moveFromValue.value === 0 && (
                              <FormattedMessage
                                id='Load.AutomationWorkflow.EndConditionMoveRecap'
                                values={{
                                  strong: escapeStrong,
                                  GROUPNAME1: intl.formatMessage({
                                    id: 'Load.AutomationWorkflow.EndConditionMoveFromAnyGroup'
                                  }),
                                  GROUPNAME2: moveToValue.label
                                }}
                              />
                            )}
                        </p>
                      </S.ItemUnique>
                    )}

                    {!fixedSteps && (
                      <S.ItemActions>
                        <ButtonAction
                          type={ACTION_BUTTON_TYPE_EDIT}
                          onClick={() => {
                            setModalEndConditionState((prev) => ({
                              ...prev,
                              show: true
                            }))
                          }}
                        />
                      </S.ItemActions>
                    )}
                  </S.WorkflowBuilderItem>
                </S.InnerItem>
              </S.Item>
            </S.DropAreaContainer>
          </S.RightContent>
        </S.RightContainer>
      </DragDropContext>
    </S.WorkflowBuilderContainer>
  )
}

export default WorkflowBuilder

WorkflowBuilder.defaultProps = {
  items: [
    {
      id: uniqid(),
      label: 'Lorem'
    },
    {
      id: uniqid(),
      label: 'Ipsum',
      isDragDisabled: false
    },
    {
      id: uniqid(),
      label: 'Dolor'
    }
  ],
  saved: []
}

WorkflowBuilder.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array,
  saved: PropTypes.array
}
